import { render, staticRenderFns } from "./FileAttachmentModal.vue?vue&type=template&id=9d08c07c&scoped=true&"
import script from "./FileAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./FileAttachmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d08c07c",
  null
  
)

export default component.exports